import React, {Component} from 'react'
import PropTypes from 'prop-types'

class NoOrders extends Component {
    render() {
        const {loading} = this.props

        if (loading) {
            return null
        }

        return (
            <tr className='NoOrders'>
                <td colSpan={14}><i>No items</i></td>
            </tr>
        )
    }
}

NoOrders.propTypes = {
    loading: PropTypes.bool.isRequired,
}

export default NoOrders
